import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { MatDialog } from "@angular/material/dialog";
import * as moment from "moment";
import { JwtHelperService } from "@auth0/angular-jwt";
import { PromotionsService } from "src/app/features/promotions/promotions.service";
import * as Quill from "quill";
import { forkJoin } from "rxjs";

const helper = new JwtHelperService();

@Component({
  selector: "app-edit-consumer-banner",
  templateUrl: "./edit-consumer-banner.component.html",
  styleUrls: ["./edit-consumer-banner.component.scss"],
})
export class EditConsumerBannerComponent
  extends FeaturesBaseComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @Input() codeGroups;
  @Input() carrierDetails;
  @Input() serviceCountries;
  consumerPromotionForm: FormGroup;
  bannerPromoId: any;
  bannerPromoDetails: any;
  promotionsCarriers: any = [];
  skulist: any = [];
  productdetails: any;
  productName: string;
  userRole: string = "";
  readonly: boolean = false;
  promoResponseDetails: any;
  fileToUpload: File = null;
  fileuploaded: boolean = false;
  uploadpic: boolean;
  minDate: Date = new Date();
  profilePicPath: any;
  carrierPromoDetails: any;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private promotionService: PromotionsService
  ) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this.bannerPromoId = this.activeRoute.snapshot.params.id;
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.toastrService.info(
      "Banner Image will reflect after saving changes",
      "Info",
      {
        timeOut: 3000,
      }
    );
    this.uploadpic = true;

    // this.selectedImageName = this.fileToUpload.name
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.consumerPromotionForm = new FormGroup({
      promotionName: new FormControl("", []),
      promotionHeader: new FormControl("", [Validators.required]),
      promotionDescription: new FormControl("", [Validators.required]),
      promotionNameText: new FormControl("", []),
      promotionDescriptionText: new FormControl("", []),
      promotionNameApp: new FormControl("", [Validators.required]),
      promotionDescriptionApp: new FormControl("", [Validators.required]),
      additionalInfo: new FormControl("", []),
      minTopUpAmount: new FormControl(""),
      vendorName: new FormControl(""),
      promotionStartdttm: new FormControl("", [Validators.required]),
      promotionEnddttm: new FormControl("", [Validators.required]),
      applicableMinAmount: new FormControl("", [Validators.required]),
      applicableMaxAmount: new FormControl("", [Validators.required]),
      tilaCodeGroup: new FormControl("", [Validators.required]),
      tilaCountry: new FormControl("", [Validators.required]),
      tilaCarrier: new FormControl("", [Validators.required]),
      tilaProductId: new FormControl("", [Validators.required]),
      isCertified: new FormControl(true, null),
      videoUrl: new FormControl(""),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["codeGroups"]) {
      this.codeGroups = changes["codeGroups"].currentValue;
    }

    if (changes["serviceCountries"]) {
      this.serviceCountries = []; //changes['serviceCountries'].currentValue;
    }
    if (changes["carrierDetails"]) {
      this.carrierDetails = changes["carrierDetails"].currentValue;
      if (this.carrierDetails && this.carrierDetails) {
        this.carrierPromoDetails = this.carrierDetails;
        this.ongetCountries();
        this.ongetCarriersList();
        this.ongetsku();

        this.consumerPromotionForm
          .get("promotionName")
          .setValue(this.carrierPromoDetails.editedPromotionName);
        this.consumerPromotionForm
          .get("promotionHeader")
          .setValue(this.carrierPromoDetails.promotionHeaderEnglish);
        this.consumerPromotionForm
          .get("promotionDescription")
          .setValue(this.carrierPromoDetails.editedPromotionDescription);
        this.consumerPromotionForm
          .get("promotionNameText")
          .setValue(this.carrierPromoDetails.editedPromotionNameTxtMsg);
        this.consumerPromotionForm
          .get("promotionDescriptionText")
          .setValue(this.carrierPromoDetails.editedPromotionDescTxtMsg);
        this.consumerPromotionForm
          .get("promotionNameApp")
          .setValue(this.carrierPromoDetails.editedPromotionNameApp);
        this.consumerPromotionForm
          .get("promotionDescriptionApp")
          .setValue(this.carrierPromoDetails.editedPromotionDescApp);
        this.consumerPromotionForm
          .get("additionalInfo")
          .setValue(this.carrierPromoDetails.additionalInfo);
        this.consumerPromotionForm
          .get("vendorName")
          .setValue(this.carrierPromoDetails.vendorName);
        this.consumerPromotionForm
          .get("promotionStartdttm")
          .setValue(
            moment(this.carrierPromoDetails.promotionStartdttm).format()
          );
        this.consumerPromotionForm
          .get("promotionEnddttm")
          .setValue(moment(this.carrierPromoDetails.promotionEnddttm).format());
        this.consumerPromotionForm
          .get("applicableMaxAmount")
          .setValue(this.carrierPromoDetails.applicableMaxAmount);
        this.consumerPromotionForm
          .get("applicableMinAmount")
          .setValue(this.carrierPromoDetails.applicableMinAmount);
        this.consumerPromotionForm
          .get("tilaCodeGroup")
          .setValue(this.carrierPromoDetails.tilaCodeGroup);
        this.consumerPromotionForm
          .get("tilaCountry")
          .setValue(this.carrierPromoDetails.tilaCountry);
        this.consumerPromotionForm
          .get("tilaProductId")
          .setValue(this.carrierPromoDetails.tilaProductId);
        this.consumerPromotionForm
          .get("tilaCarrier")
          .setValue(this.carrierPromoDetails.tilaCarrier);
        this.consumerPromotionForm
          .get("videoUrl")
          .setValue(this.carrierPromoDetails.videoUrl);
        this.consumerPromotionForm
          .get("isCertified")
          .setValue(
            this.carrierPromoDetails.isCertified == "Yes" ? true : false
          );
        this.consumerPromotionForm
          .get("minTopUpAmount")
          .setValue(this.carrierPromoDetails.minTopUpAmount);
      }
    }
  }

  ngAfterViewInit(): void {}

  get f() {
    return this.consumerPromotionForm.controls;
  }

  onBannerFormSubmit(e) {
    if (this.consumerPromotionForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: "pages.placeholders.Areyousureyouwanttosavethechanges",
          buttonText: {
            ok: "pages.placeholders.Save",
            cancel: "pages.placeholders.cancel",
          },
        },
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters();
        } else {
          this.router.navigate([
            "features/consumers/consumer-banner/manage-banner",
          ]);
        }
      });
    }
  }

  setSubmitParameters() {
    const formData: FormData = new FormData();
    formData.append(
      "editedPromotionName",
      this.consumerPromotionForm.get("promotionName")?.value
    );
    formData.append(
      "promotionHeaderEnglish",
      this.consumerPromotionForm.get("promotionHeader")?.value
    );
    formData.append(
      "editedPromotionDescription",
      this.consumerPromotionForm.get("promotionDescription")?.value
    );
    formData.append(
      "editedPromotionNameTxtMsg",
      this.consumerPromotionForm.get("promotionNameText")?.value
    );
    formData.append(
      "editedPromotionDescTxtMsg",
      this.consumerPromotionForm.get("promotionDescriptionText")?.value
    );
    formData.append(
      "editedPromotionNameApp",
      this.consumerPromotionForm.get("promotionNameApp")?.value
    );
    formData.append(
      "editedPromotionDescApp",
      this.consumerPromotionForm.get("promotionDescriptionApp")?.value
    );
    formData.append(
      "additionalInfo",
      this.consumerPromotionForm.get("additionalInfo")?.value
    );
    formData.append(
      "vendorName",
      this.consumerPromotionForm.get("vendorName")?.value
    );
    formData.append("promotionImage", this.fileToUpload);
    formData.append(
      "promotionStartdttm",
      moment(this.consumerPromotionForm.get("promotionStartdttm").value).format(
        "MM/DD/YYYY"
      )
    );
    formData.append(
      "promotionEnddttm",
      moment(this.consumerPromotionForm.get("promotionEnddttm").value).format(
        "MM/DD/YYYY"
      )
    );
    formData.append(
      "applicableMinAmount",
      this.consumerPromotionForm.get("applicableMinAmount")?.value
    );
    formData.append(
      "applicableMaxAmount",
      this.consumerPromotionForm.get("applicableMaxAmount")?.value
    );
    formData.append(
      "tilaCodeGroup",
      this.consumerPromotionForm.get("tilaCodeGroup")?.value
    );
    formData.append(
      "tilaCountry",
      this.consumerPromotionForm.get("tilaCountry")?.value
    );
    formData.append(
      "tilaCarrier",
      this.consumerPromotionForm.get("tilaCarrier")?.value
    );
    formData.append(
      "tilaProductId",
      this.consumerPromotionForm.get("tilaProductId")?.value
    );
    formData.append(
      "isCertified",
      this.consumerPromotionForm.get("isCertified").value ? "Yes" : "No"
    );
    formData.append(
      "videoUrl",
      this.consumerPromotionForm.get("videoUrl")?.value
    );

    this.promotionService
      .updateConsumerPromotions(this.bannerPromoId, formData)
      .subscribe({
        next: (res) => {
          if (res.responseStatus == "Success") {
            this.router.navigate([
              "features/consumers/consumer-banner/manage-banner",
            ]);
            this.toastrService.success(
              "Consumer Promotion added successfully",
              "Success",
              {
                timeOut: 3000,
              }
            );
          }
        },
      });
  }

  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: "pages.placeholders.Areyousureyouwanttocancelthechanges",
        buttonText: {
          ok: "pages.newRetailer.yes",
          cancel: "pages.newRetailer.cancel",
        },
      },
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl(
          "features/consumers/consumer-banner/manage-banner"
        );
      }
    });
  }

  getCountries(e) {
    let CodeGroup = this.consumerPromotionForm.get("tilaCodeGroup").value;
    this.serviceCountries = [];
    this.promotionService.getCountries(CodeGroup).subscribe((res) => {
      let _carriers: any = res;
      if (_carriers.httpcode == 200) {
        this.serviceCountries = _carriers.data;
        this.promotionsCarriers = [];
        this.skulist = [];
      }
    });
  }

  getCarriersList(e) {
    let CodeGroup = this.consumerPromotionForm.get("tilaCodeGroup").value;
    let country = this.consumerPromotionForm.get("tilaCountry").value;
    this.promotionsCarriers = [];
    this.promotionService
      .getCarriersList(CodeGroup, country)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;
          this.skulist = [];
        }
      });
  }

  ongetCountries() {
    let CodeGroup = this.carrierPromoDetails.tilaCodeGroup;
    this.promotionService.getCountries(CodeGroup).subscribe((res) => {
      let _carriers: any = res;
      if (_carriers.httpcode == 200) {
        this.serviceCountries = _carriers.data;
      }
    });
  }
  ongetCarriersList() {
    let CodeGroup = this.carrierPromoDetails.tilaCodeGroup;
    let country = this.carrierPromoDetails.tilaCountry;
    this.promotionService
      .getCarriersList(CodeGroup, country)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;
        }
      });
  }
  ongetsku() {
    ///getcarriers
    let country = this.carrierPromoDetails.tilaCountry;
    let CodeGroup = this.carrierPromoDetails.tilaCodeGroup;
    let carrier = this.carrierPromoDetails.tilaCarrier;

    this.promotionService
      .getConsumerSkuList(country, CodeGroup, carrier)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.skulist = _carriers.data;
        }
      });
  }

  getcarriers(e) {
    ///getcarriers
    let CodeGroup: any = Array();
    CodeGroup.push(this.consumerPromotionForm.get("tilaCodeGroup").value);
    let country = this.consumerPromotionForm.get("tilaCountry").value;
    this.promotionService
      .getCarrierNamesbycountrycodegroup(country, CodeGroup)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;
        }
      });
  }

  getsku(e) {
    ///getcarriers
    let country = this.consumerPromotionForm.get("tilaCountry").value;
    let CodeGroup = this.consumerPromotionForm.get("tilaCodeGroup").value;
    let carrier = this.consumerPromotionForm.get("tilaCarrier").value;

    this.promotionService
      .getConsumerSkuList(country, CodeGroup, carrier)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.skulist = _carriers.data;
        }
      });
  }

  onCheckCertify(e) {
    //alert(e.value)
  }

  checkSubmitDisplayed() {
    return !(
      this.consumerPromotionForm.valid && !this.consumerPromotionForm.pristine
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
